import { ControlledToggleButtonGroup, UncontrolledTextFieldDebounced } from '@if/mui'
import { Box, Button, Typography } from '@mui/material'
import { JSX } from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface ManualLinkFormValues {
  applicationNumber: string
  numberType: 'dcc' | 'cvt'
  financingType: 'fa' | 'ifx' | 'if'
}

interface ManualLinkFormProps {
  control: Control<ManualLinkFormValues>
  numberType: 'dcc' | 'cvt'
  numberTypeOptions: JSX.Element[]
  financingTypeOptions: JSX.Element[]
  isPending: boolean
  onCancel: () => void
}

const ManualLinkForm = ({
  control,
  numberType,
  numberTypeOptions,
  financingTypeOptions,
  isPending,
  onCancel,
}: ManualLinkFormProps) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ mt: 3, p: 2, border: 1, borderColor: 'divider', borderRadius: 1 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t('docsAutomation.manualLink')}
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'end', mb: 2 }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            {t('common.applicationReferenceNumber')}
          </Typography>
          <UncontrolledTextFieldDebounced
            control={control}
            name="applicationNumber"
            label={numberType === 'dcc' ? t('common.dccNumber') : t('common.cvtNumber')}
            type="number"
            fullWidth={false}
            size="small"
            sx={{ width: '100%' }}
          />
        </Box>

        <ControlledToggleButtonGroup
          control={control}
          name="numberType"
          exclusive
          color="primary"
          size="small"
          options={numberTypeOptions}
        />
      </Box>

      <Box>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
          {t('common.financingType')}
        </Typography>
        <ControlledToggleButtonGroup
          control={control}
          name="financingType"
          exclusive
          color="primary"
          size="small"
          options={financingTypeOptions}
          fullWidth
        />
      </Box>

      <Box sx={{ mt: 2, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button onClick={onCancel} disabled={isPending}>
          {t('common.cancel')}
        </Button>
      </Box>
    </Box>
  )
}

export default ManualLinkForm
